module.exports = __webpack_public_path__ + "img/image-login.4ba4e692.png";